var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "www flex-h-center" }, [
      _c("div", {
        staticStyle: { display: "inline-block" },
        attrs: { id: "wx_reg" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }